/* Header rating — ancien widget (.jdgm-) */
(() => {
  const SELECTOR = '.jdgm-header-info .jdgm-rating-text';

  function apply() {
    const el = document.querySelector(SELECTOR);
    if (!el) return false;

    const raw = (el.textContent || '').trim();
    const noteMatch = raw.match(/^([0-9]+(?:[.,][0-9]+)?)/);
    const reviewsMatch = raw.match(/\((\d+)\)/);

    if (!noteMatch || !reviewsMatch) return false;

    const noteRaw = parseFloat(noteMatch[1].replace(',', '.'));
    const note = noteRaw.toFixed(2);
    const reviews = reviewsMatch[1];
    const desired = `${note} / 5 sur ${reviews} avis`;

    if (el.textContent.trim() !== desired) {
      el.textContent = desired;
    }
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }

  const obs = new MutationObserver(() => {
    if (apply()) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(apply, 1500);
})();

/* Header rating — nouveau widget (.jm-) : "4.9  32 avis" → "4.94 / 5 sur 32 avis" */
(() => {
  function applyNew() {
    const container = document.querySelector('.jm-average-rating-display');
    if (!container || container.dataset.ezFormatted === 'true') return false;

    const texts = container.querySelectorAll('p.jm-text');
    if (texts.length < 2) return false;

    /* Chercher la note exacte depuis le badge Judge.me (plus précis que le texte affiché) */
    const badge = document.querySelector('.jdgm-prev-badge[data-average-rating]');
    const ratingExact = badge ? parseFloat(badge.getAttribute('data-average-rating')) : NaN;
    const ratingText = parseFloat((texts[0].textContent || '').trim().replace(',', '.'));
    const ratingRaw = !isNaN(ratingExact) ? ratingExact : ratingText;
    const countMatch = (texts[1].textContent || '').trim().match(/(\d+)/);
    if (isNaN(ratingRaw) || !countMatch) return false;

    const note = ratingRaw.toFixed(2);
    const count = countMatch[1];

    /* Remplacer le contenu du cluster par un seul texte */
    const cluster = container.querySelector('.jm-cluster');
    if (!cluster) return false;

    /* Cacher les éléments existants */
    Array.from(cluster.children).forEach(child => child.style.display = 'none');

    /* Injecter le nouveau texte */
    const span = document.createElement('p');
    span.className = 'jm-text';
    span.style.cssText = 'font-size: var(--jm-heading-sm-size); font-weight: var(--jm-heading-sm-weight-bold); line-height: 1;';
    span.textContent = `${note} / 5 sur ${count} avis`;
    cluster.appendChild(span);

    container.dataset.ezFormatted = 'true';
    return true;
  }

  const obs = new MutationObserver(() => {
    if (applyNew()) obs.disconnect();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(applyNew, 1500);
  setTimeout(applyNew, 3000);
})();



/* Badge preview produit : "★★★★★ 22 avis" → "★★★★★ 4.91 / 5 sur 22 avis" */
(() => {
  /* Injecter le CSS une seule fois pour rendre le vrai texte visible */
  const style = document.createElement('style');
  style.textContent = `
    .jdgm-prev-badge__text.jdgm-badge-text-override {
      visibility: visible !important;
      font-size: 16px !important;
      font-family: 'Nunito Sans', sans-serif !important;
      font-weight: 700 !important;
    }
    @media (min-width: 990px) {
      .jdgm-prev-badge__text.jdgm-badge-text-override {
        font-size: 18px !important;
      }
    }
    .jdgm-prev-badge__text.jdgm-badge-text-override::before,
    .jdgm-prev-badge__text.jdgm-badge-text-override::after {
      display: none !important;
    }
    .jdgm-preview-badge .jdgm-prev-badge__stars {
      font-size: 20px !important;
    }
    .jdgm-preview-badge .jdgm-star {
      font-size: 20px !important;
    }
    @media (min-width: 990px) {
      .jdgm-preview-badge .jdgm-prev-badge__stars {
        font-size: 22px !important;
      }
      .jdgm-preview-badge .jdgm-star {
        font-size: 22px !important;
      }
    }
    /* Cartes collection : tailles réduites */
    .product-tile .jdgm-preview-badge .jdgm-prev-badge__stars,
    .product-tile .jdgm-preview-badge .jdgm-star {
      font-size: 14px !important;
    }
    .product-tile .jdgm-prev-badge__text.jdgm-badge-text-override {
      font-size: 12px !important;
    }
    .product-tile .jdgm-widget.jdgm-preview-badge {
      padding: 0 !important;
      margin-top: 4px !important;
      line-height: 1.2 !important;
    }
    @media (min-width: 990px) {
      .product-tile .jdgm-preview-badge .jdgm-prev-badge__stars,
      .product-tile .jdgm-preview-badge .jdgm-star {
        font-size: 15px !important;
      }
      .product-tile .jdgm-prev-badge__text.jdgm-badge-text-override {
        font-size: 13px !important;
      }
    }
  `;
  document.head.appendChild(style);

  function formatPreviewBadge() {
    document.querySelectorAll('.jdgm-prev-badge[data-average-rating]').forEach(badge => {
      const rating = badge.getAttribute('data-average-rating');
      const count  = badge.getAttribute('data-number-of-reviews');
      if (!rating || !count) return;
      const isCard = badge.closest('.product-tile') !== null;
      const desired = isCard
        ? `(${count} avis)`
        : `${rating} / 5 sur ${count} avis`;
      badge.querySelectorAll('.jdgm-prev-badge__text').forEach(el => {
        el.classList.add('jdgm-badge-text-override');
        if (el.textContent.trim() !== desired) {
          el.textContent = desired;
        }
      });
    });
  }

  const obs = new MutationObserver(() => formatPreviewBadge());
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(formatPreviewBadge, 1000);
  setTimeout(formatPreviewBadge, 2500);
  setTimeout(formatPreviewBadge, 5000);
})();

/* Badge note globale sur la bannière home */
(() => {
  function fillHomeBanner() {
    const container = document.getElementById('ez-home-rating');
    if (!container || container.dataset.filled === 'true') return false;

    /* Lire depuis le header Judge.me du carrousel avis (même page) */
    const ratingTextEl = document.querySelector('.jdgm-header-info .jdgm-rating-text');
    if (ratingTextEl && ratingTextEl.textContent.trim()) {
      const textEl = document.getElementById('ez-home-rating-text');
      if (textEl) textEl.textContent = ratingTextEl.textContent.trim();
      container.style.display = '';
      container.dataset.filled = 'true';
      return true;
    }
    return false;
  }

  const obs = new MutationObserver(() => { if (fillHomeBanner()) obs.disconnect(); });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(fillHomeBanner, 1500);
  setTimeout(fillHomeBanner, 3000);
  setTimeout(fillHomeBanner, 5000);
})();

(function () {
  function formatReviewerNames() {
    const names = document.querySelectorAll('.jdgm-reviewer-name');

    names.forEach(el => {
      if (el.dataset.formatted === 'true') return;

      let text = el.textContent.trim();
      if (!text) return;

      // Ignore "Anonyme"
      if (/^anonyme$/i.test(text)) return;

      // Nettoyage
      text = text.replace(/\s+/g, ' ').toLowerCase();

      const parts = text.split(' ');
      if (parts.length < 1) return;

      const firstName =
        parts[0].charAt(0).toUpperCase() + parts[0].slice(1);

      let lastInitial = '';
      if (parts.length > 1) {
        lastInitial = parts[parts.length - 1].charAt(0).toUpperCase() + '.';
      }

      el.textContent = lastInitial
        ? `${firstName} ${lastInitial}`
        : firstName;

      el.dataset.formatted = 'true';
    });
  }

  // Run once DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatReviewerNames);
  } else {
    formatReviewerNames();
  }

  // Observer (Judge.me injecte dynamiquement)
  const obs = new MutationObserver(() => formatReviewerNames());
  obs.observe(document.body, { childList: true, subtree: true });
})();

